// extracted by mini-css-extract-plugin
export default {"FullTag":"FullTag-module-edbf39df19c53beb04f0"};